import React, { useEffect, useRef, useState } from 'react';
import './abt_me.css';
import profileImage from '../../../assets/images/me.JPG';

export const AboutMe = () => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);

  return (
    <section
      id="AboutMe"
      className={`about-section ${visible ? 'visible' : ''}`}
      ref={ref}
      aria-label="About Me"
    >
      <div className="container">
        <div className="section-header">
          <h2>ABOUT</h2>
        </div>

        <div className="terminal-window about-terminal">
          <div className="terminal-header">
            <div className="dots">
              <span className="dot active"></span>
              <span className="dot"></span>
              <span className="dot"></span>
            </div>
            <span>operator_profile.sys</span>
          </div>

          <div className="terminal-body">
            <div className="about-grid">
              {/* Image column */}
              <div className="about-image-col">
                <div className="image-frame">
                  <img src={profileImage} alt="Amrinder Bhogal — Environmental Engineer" className="profile-img" />
                  <div className="image-scanlines"></div>
                </div>
                <div className="image-label">{'// OPERATOR PHOTO'}</div>
              </div>

              {/* Info column */}
              <div className="about-info-col">
                <div className="terminal-prompt">
                  <span className="prompt-sym">&gt;</span> cat ./about.txt
                </div>

                <div className="about-bio">
                  <p>
                    Environmental Engineering graduate from the{' '}
                    <span className="hl">University of Guelph</span> with a passion for
                    real estate and land development.
                  </p>
                  <p>
                    As a third-generation engineer, I am driven by a passion for creation
                    and innovation. I channel my entrepreneurial spirit into new ventures,
                    currently focusing on integrating{' '}
                    <span className="hl">technology with civil engineering</span> to
                    drive efficiency.
                  </p>
                </div>

                <div className="about-meta">
                  <div className="meta-row">
                    <span className="meta-key">LOCATION</span>
                    <span className="meta-val">Caledon East, ON</span>
                  </div>
                  <div className="meta-row">
                    <span className="meta-key">EMAIL</span>
                    <span className="meta-val">
                      <a href="mailto:amrinderbhogal06@gmail.com">amrinderbhogal06@gmail.com</a>
                    </span>
                  </div>
                  <div className="meta-row">
                    <span className="meta-key">PHONE</span>
                    <span className="meta-val">647-535-8655</span>
                  </div>
                  <div className="meta-row">
                    <span className="meta-key">STATUS</span>
                    <span className="meta-val online">
                      <span className="online-dot"></span> AVAILABLE
                    </span>
                  </div>
                </div>

                <div className="about-actions">
                  <a
                    href="https://www.linkedin.com/in/amrinderb"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="crt-button"
                  >
                    LINKEDIN
                  </a>
                  <a
                    href="https://github.com/Amrinder-B"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="crt-button"
                  >
                    GITHUB
                  </a>
                </div>

                <div className="terminal-prompt">
                  <span className="prompt-sym">&gt;</span>{' '}
                  <span className="cursor-blink">_</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
